import client, { ApiResponse } from './client';

export interface StartGameResponse {
  gameId: string;
  nonce: string;
  serverTime: number;
}

export const startGame = async (): Promise<StartGameResponse> => {
  const response = await client.get<ApiResponse<StartGameResponse>>('/game/start');
  return response.data.data;
};

export interface ClaimRewardRequest {
  gameId: string;
  token: string;
  clickTime: number;
}

export interface ClaimRewardResponse {
  reward: number;
  nextGameId: string;
  nextNonce: string;
  currentBalance: string;
}

export const claimReward = async (data: ClaimRewardRequest): Promise<ClaimRewardResponse> => {
  const response = await client.post<ApiResponse<ClaimRewardResponse>>('/game/reward', data);
  return response.data.data;
};
